import { AfterViewInit, Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { NgbModal, ModalDismissReasons, NgbDateStruct, NgbCalendar } from '@ng-bootstrap/ng-bootstrap';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ApiService } from '../../../core/api.service';
import { FunctionsService } from '../../../core/global/functions.service';
import { UtilityService } from '../../../core/global/utility.service';
import { AngularEditorConfig } from '@kolkov/angular-editor';
@Component({
  selector: 'app-user-role-add-model',
  templateUrl: './user-role-add-model.component.html',
  styleUrls: ['./user-role-add-model.component.sass']
})
export class UserRoleAddModelComponent implements AfterViewInit {
  @ViewChild('agenda') replace: ElementRef
  public defaultUpdateId = '';
  addUserObj: any = {};
  orgList = []
  searchInput: any = '';
  sortedtby: any = 'id';
  page: number = 0; // Enter 1 if you want to use the server side pagination 
  p;
  updateId = '';
  orgName = [];
  userList = [];
  presentDate = new Date();
  presentMonth = this.presentDate.getMonth() + 1;
  year = this.presentDate.getFullYear();
  meridian = true;
  time = { hour: this.presentDate.getHours(), minute: this.presentDate.getMinutes() };
  day_1_date = { year: this.year, month: this.presentMonth, day: this.presentDate.getDate() };
  day_2_date = { year: this.year, month: this.presentMonth, day: this.presentDate.getDate() + 1 };
  day_3_date = { year: this.year, month: this.presentMonth, day: this.presentDate.getDate() + 2 };
  htmlContent = '';
  config: AngularEditorConfig = {
    editable: true,
    spellcheck: true,
    height: 'auto',
    minHeight: '0',
    maxHeight: 'auto',
    width: 'auto',
    minWidth: '0',
    translate: 'yes',
    enableToolbar: true,
    showToolbar: true,
    placeholder: 'Enter text here...',
    defaultParagraphSeparator: '',
    defaultFontName: '',
    defaultFontSize: '',
    fonts: [
      { class: 'arial', name: 'Arial' },
      { class: 'times-new-roman', name: 'Times New Roman' },
      { class: 'calibri', name: 'Calibri' },
      { class: 'comic-sans-ms', name: 'Comic Sans MS' }
    ],
    customClasses: [
      {
        name: 'quote',
        class: 'quote',
      },
      {
        name: 'redText',
        class: 'redText'
      },
      {
        name: 'titleText',
        class: 'titleText',
        tag: 'h1',
      },
    ],
    uploadUrl: 'v1/image',
    uploadWithCredentials: false,
    sanitize: true,
    toolbarPosition: 'top',
    toolbarHiddenButtons: [
      ['bold', 'italic'],
      ['fontSize']
    ]
  };
  gateList: any = [];
  date = { year: this.year, month: this.presentMonth, day: this.presentDate.getDate() };
  constructor(public activeModal: NgbActiveModal, private modalService: NgbModal, private _adminService: ApiService, private _functions: FunctionsService, private _utility: UtilityService) { }
  async ngAfterViewInit(): Promise<void> {
    var select = document.getElementsByTagName('i')
    for (let index = 0; index < select.length; index++) {
      if (select[index].classList[0] == 'fa') {
        select[index].classList.remove('fa')
        select[index].classList.add('fas')
      }
    }
  }
  async ngOnInit(): Promise<void> {
    this.updateId = window.localStorage.getItem('pushUserId');
    window.localStorage.removeItem('pushUserId');
    this.addUserObj.day = 1
    this.addUserObj.user_role = '1'
    this.addUserObj.org_ref_id = ''
    this.addUserObj.user_ref_id = ''
    this.addUserObj.breakfast_valid = ''
    this.addUserObj.lunch_valid = ''
    this.addUserObj.tea_valid = ''
    this.addUserObj.dinner_valid = ''
    await this.getOrg()
  }

  async getOrg() {
    this._utility.showLoader()
    let data = { searchText: this.searchInput, sortby: this.sortedtby, page: this.page };
    let url = "qr/org_list";
    this._adminService.post(url, data).subscribe(async (response) => {
      this._utility.hideLoader()
      if (await response.success == true) {
        if (await response.data.length > 0) {
          this.orgList = await response.data
          this.addUserObj.org_ref_id = await response.data[0].id
          if (this.updateId) {
            await this.getUserRoleDetails()
          } else {
            await this.onOrgChange(await response.data[0].id, this.addUserObj.day)
          }
        }
      }
    })
  }
  async getUserRoleDetails() {
    let wheredata = []
    this._utility.showLoader()
    wheredata = [{ 'field': '`qr_user_role`.`id`', 'value': this.updateId, 'type': 'WHERE', 'nested': '' }]
    let data = { whereData: wheredata, searchText: this.searchInput, sortby: this.sortedtby, page: this.page };
    let url = "qr/user_role_list";
    this._adminService.post(url, data).subscribe(async (response) => {
      this._utility.hideLoader()
      if (response.success == true) {
        await this.onOrgChange(await response.data[0].org_ref_id, await response.data[0].day);
        this.addUserObj.org_ref_id = await response.data[0].org_ref_id
        this.addUserObj.day = (await response.data[0].day)
        this.addUserObj.user_role = (await response.data[0].user_role.toString())
        this.addUserObj.user_ref_id = await response.data[0].user_id;
        await this.onUserChange(this.addUserObj.user_ref_id);
        this.addUserObj.breakfast_valid = this._functions.validateZeroOne(await response.data[0].breakfast_valid);
        this.addUserObj.lunch_valid = this._functions.validateZeroOne(await response.data[0].lunch_valid);
        this.addUserObj.tea_valid = this._functions.validateZeroOne(await response.data[0].tea_valid);
        this.addUserObj.dinner_valid = this._functions.validateZeroOne(await response.data[0].dinner_valid);
        let breakfast_gate_id = await response.data[0].breakfast_gate != '' ? await response.data[0].breakfast_gate.split(',') : [];

        let lunch_gate_id = await response.data[0].lunch_gate != '' ? await response.data[0].lunch_gate.split(',') : [];
        let tea_gate_id = await response.data[0].tea_gate != '' ? await response.data[0].tea_gate.split(',') : [];
        let dinner_gate_id = await response.data[0].dinner_gate != '' ? await response.data[0].dinner_gate.split(',') : [];
        this.addUserObj.breakfast_gate = breakfast_gate_id ? breakfast_gate_id.map(Number) : [];
        this.addUserObj.lunch_gate = lunch_gate_id ? lunch_gate_id.map(Number) : [];
        this.addUserObj.tea_gate = lunch_gate_id ? tea_gate_id.map(Number) : [];
        this.addUserObj.dinner_gate = lunch_gate_id ? dinner_gate_id.map(Number) : [];
        this.addUserObj.agenda = await response.data[0].agenda;
        this.addUserObj.speaking_engagement = await response.data[0].speaking_engagement;
        this.addUserObj.dinning = await response.data[0].dinning;
        this.addUserObj.about_us = await response.data[0].about_us;
      }
    })
  }
  async onOrgChange(event, day: number) {
    this._utility.showLoader()
    let org = this.orgList.filter(el => el.id == event)
    let wheredata = []
    wheredata = [{ 'field': '`qr_user`.`org_ref_id`', 'value': event, 'type': 'WHERE', 'nested': '' }]
    let data = { whereData: wheredata, searchText: this.searchInput, sortby: this.sortedtby, page: this.page };
    let url = "qr/user_list";
    this._adminService.post(url, data).subscribe(async (response) => {
      let date = new Date(await org[0].start_date)
      this.day_1_date = { year: date.getFullYear(), month: (date.getMonth() + 1), day: date.getDate() };
      //this.day_2_date = { year: date.getFullYear(), month: (date.getMonth() + 1), day: date.getDate() + 1 };
      //this.day_3_date = { year: date.getFullYear(), month: (date.getMonth() + 1), day: date.getDate() + 2 };

            // Create Day 2 by adding 1 day
      let day_2 = new Date(date);
      day_2.setDate(date.getDate() + 1); // Add 1 day to the date
      this.day_2_date = { 
        year: day_2.getFullYear(), 
        month: (day_2.getMonth() + 1), 
        day: day_2.getDate() 
      };

      // Create Day 3 by adding 2 days
      let day_3 = new Date(date);
      day_3.setDate(date.getDate() + 2); // Add 2 days to the date
      this.day_3_date = { 
        year: day_3.getFullYear(), 
        month: (day_3.getMonth() + 1), 
        day: day_3.getDate() 
      };
      if (day === 1) {
        this.date = this.day_1_date
      }
      if (day === 2) {
        this.date = this.day_2_date
      }
      if (day === 3) {
        this.date = this.day_3_date
      }
      this.dateChange();
      this._utility.hideLoader()
      if (await response.success == true) {
        this._utility.showLoader()
        this.userList = await response.data
        let data = { org_id: event }
        let url = "qr/gate_details";

        this._adminService.post(url, data).subscribe(async (response) => {
          this._utility.hideLoader()
          if (response.success == true) {
            this.gateList = await response.data
          }
        })
      }
    })
  }
  async onUserChange(event) {
    this.addUserObj.user_ref_id = await event
  }
  onRoleChange(event) {

  }
  onBreakfastChange(event) {

  }
  onLunchChange(event) {

  }
  onTeaChange(event) {

  }
  onDinnerChange(event) {

  }
  onDayChange(event) {
    if (event === 1) {
      this.date = this.day_1_date
    }
    if (event === 2) {
      this.date = this.day_2_date
    }
    if (event === 3) {
      this.date = this.day_3_date
    }
    this.dateChange();
  }
  async dateChange() {
    let mysqlformatDate = this.date['year'] + '-' + ('0' + this.date['month']).slice(-2) + '-' + ('0' + this.date['day']).slice(-2);
    this.addUserObj.date = mysqlformatDate;
  }
  save() {
    this.addUserObj.breakfast_valid = this._functions.validateTruefalse(this.addUserObj.breakfast_valid);
    this.addUserObj.lunch_valid = this._functions.validateTruefalse(this.addUserObj.lunch_valid);
    this.addUserObj.tea_valid = this._functions.validateTruefalse(this.addUserObj.tea_valid);
    this.addUserObj.dinner_valid = this._functions.validateTruefalse(this.addUserObj.dinner_valid);
    var error = 0;
    if (!this.addUserObj.day) {
      error++;
      this._utility.toastWarning('Select Day');
    } else if (!this.addUserObj.user_role) {
      error++;
      this._utility.toastWarning('Select Role');
    }
    else if (!this.addUserObj.org_ref_id) {
      error++;
      this._utility.toastWarning('Select Event');
    }
    else if (!this.addUserObj.user_ref_id) {
      error++;
      this._utility.toastWarning('Select User');
    }
    else if ((this.addUserObj.breakfast_valid == 1 && !this.addUserObj.breakfast_gate) || (this.addUserObj.breakfast_valid == 1 && this.addUserObj.breakfast_gate == 0)) {
      error++;
      this._utility.toastWarning('Select Breakfast Gate');
    }
    else if ((this.addUserObj.lunch_valid == 1 && !this.addUserObj.lunch_gate) || (this.addUserObj.lunch_valid == 1 && this.addUserObj.lunch_gate.length == 0)) {
      error++;
      this._utility.toastWarning('Select Lunch Gate');
    }
    else if ((this.addUserObj.tea_valid == 1 && !this.addUserObj.tea_gate) || (this.addUserObj.tea_valid == 1 && this.addUserObj.tea_gate.length == 0)) {
      error++;
      this._utility.toastWarning('Select Conversations over Kahwa Gate');
    }
    else if ((this.addUserObj.dinner_valid == 1 && !this.addUserObj.dinner_gate) || (this.addUserObj.dinner_valid == 1 && this.addUserObj.dinner_gate.length == 0)) {
      error++;
      this._utility.toastWarning('Select Dinner Gate');
    }
    else if (!this.addUserObj.agenda) {
      error++;
      this._utility.toastWarning('Enter Agenda');
    }
    else if (this.addUserObj.user_role == '1' && !this.addUserObj.speaking_engagement) {
      error++;
      this._utility.toastWarning('Enter Speaking Engagement');
    }
    else if (!this.addUserObj.dinning) {
      error++;
      this._utility.toastWarning('Enter Dinning Invite ');
    }
    if (error == 0) {
      this._utility.showLoader()
      let url = 'qr/user_role_save';
      if (this.updateId != '' && this.updateId != null) {
        this.addUserObj.updateId = this.updateId;
      }
      this._adminService.post(url, this.addUserObj).subscribe((response) => {
        this._utility.hideLoader()
        if (response.success == true) {
          this._utility.toastSuccess(response.message);
          this.activeModal.close(true);
        } else {
          this._utility.toastError(response.message);
        }
      })
    }
  }
  onItemChange(value) {
    if (value == '1') {
      this.addUserObj.is_allowed = '1';
    } else {
      this.addUserObj.is_allowed = '0';
    }
  }
}
